import { components } from './generated-schema'

export type CollectionType = components['schemas']['CollectionTypeEnum']
export type Themes = components['schemas']['ThemeList']

export type MoodGroups = components["schemas"]["MoodGroupList"]
export type MoodGroup = components["schemas"]["MoodGroup"]
export type MoodWithCover = { mood: string, covers: string[] }
export type MoodGroupListWithCover = { id: string, moods: MoodWithCover[] }

export type Locations = components["schemas"]["LocationsList"]

export type AdviceFilterAPI = components['schemas']['ApiFeature']
export type FilterMetaData = components["schemas"]["FeatureMetadata"]
export type FilterType = components["schemas"]["FeatureTypeEnum"]

export type FloatFilterData = FilterMetaData & { feature_type: 'float', value: number }
export type BooleanFilterData = FilterMetaData & { feature_type: 'boolean', value: boolean }
export type FilterData = FloatFilterData | BooleanFilterData

export type AdviceFilter = AdviceFilterAPI & { metadata: FilterData }

export const adviceSortMethods = ["match",  "popularity", "pages", "!pages", "pubdate", "!pubdate"] as const
export type AdviceSortMethod = typeof adviceSortMethods[number]

export const adviceTypes = ["book", "theme", "mood"] as const
export type AdviceType = typeof adviceTypes[number]

export type BookInfo = components["schemas"]["BookInfo"]

export type BookSearchResponse = components["schemas"]["BookSearchResponseType"]
export type BookSearch = components["schemas"]["BookSearchResponseSingle"]

export const apiToFilter: (api: AdviceFilterAPI) => AdviceFilter = (api) => {
  const { feature_type } = api.metadata
  switch (feature_type) {
    case 'float': return { ...api, metadata: { ...api.metadata, feature_type, value: api.metadata.starting_value } }
    // case 'boolean': return { ...api, metadata: { ...api.metadata, feature_type, value: false } }
  }
}

export type ValueType<T extends FilterType> =
  T extends "float" ? number :
  T extends "boolean" ? boolean :
  never

export type FilterValue = ValueType<FilterType>

export type CoverData = components["schemas"]["CoverData"]